import { Box, Tab, Tabs } from '@mui/material'
import { useTranslation } from 'react-i18next'

import PageHeader from '@/components/layouts/PageHeader'
import LocalPqResourceSetsDataGrid from '@/features/prequalification/localControl/components/LocalPqResourceSetsDataGrid'

function PrequalificationsIndex() {
  const { t } = useTranslation()

  return (
    <>
      <PageHeader isRoot pageTag="prequalifications" pageTitle={t('component.page_header.prequalifications')} />

      {/* Scope tabs. Only local-control exists today; `cloud` is reserved (see PqScope). */}
      <Box sx={{ mt: 2, borderBottom: 1, borderColor: 'divider' }}>
        <Tabs aria-label={t('prequalifications.scope.tabs_label')} value="local-control">
          <Tab
            disableRipple
            label={t('prequalifications.scope.local_control')}
            sx={{ minHeight: 0 }}
            value="local-control"
          />
        </Tabs>
      </Box>

      <LocalPqResourceSetsDataGrid />
    </>
  )
}

export default PrequalificationsIndex
